import type { Phrases } from '../common/Phrases.d';
import type { ButtonGroupOption } from '../../../components/react-hook-form/ButtonGroup';

import React, { useMemo } from 'react';
// import { ButtonGroup } from '../../../components/react-hook-form/ButtonGroup';
import { ButtonRadioGroup } from '/react4xp/components/react-hook-form/buttonRadioGroup/ButtonRadioGroup';
import {
	SERVICES_FIELD_NAME,
	FIELD_VALUE_IF_NALOXONE_WORKED,
} from './constants';

export const IfNaloxoneWorkedButtonGroup = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {

	const OPTIONS: ButtonGroupOption[] = useMemo(() => [{
		label: phrases['notificationForm.term.yes'],
		value: FIELD_VALUE_IF_NALOXONE_WORKED.YES,
	},{
		label: phrases['notificationForm.term.no'],
		value: FIELD_VALUE_IF_NALOXONE_WORKED.NO,
	},{
		label: phrases['notificationForm.services.ifNaloxoneWorkedField.value.naloxoneNotGiven'],
		value: FIELD_VALUE_IF_NALOXONE_WORKED.NALOXONE_NOT_GIVEN,
	}], [phrases]);

	return (
		<ButtonRadioGroup
			className='z-0'
			description={phrases['notificationForm.term.chooseOne']}
			label={phrases['notificationForm.services.ifNaloxoneWorkedField.label']}
			name={SERVICES_FIELD_NAME.IF_NALOXONE_WORKED}
			options={OPTIONS}
		/>
	);
};
